 <template>
    <div class="m-h-b-100 bg-c-F5F6F7">
        <div class="bs-border-box pad-12">
            <div
                v-for="(item, index) in memberList"
                :key="index"
                class="ds-fl bs-border-box pad-12 bg-c-w box-shadow-8090A0 bor-radiu-8 fl-dir-c mg-b-12"
                @click.stop.prevent="goDetail(item)"
            >
                <div class="ds-fl">
                    <div class="ds-fl fl-1 mg-b-12 over-hide">
                        <div :class="['w-48', 'h-48', 'bor-radiu-w-50', 'bg-init', 'bg-pos-center', 'mg-r-10']" :style="{
                            'background-image': 'url(' + item.image + ')'
                        }">

                        </div>
                        <div class="fl-1 over-hide">
                            <div class="h-21 l-21 ds-fl al-center mg-b-4 mg-t-2 over-hide wp-nw">
                                <span class="c-3 l-21 fs-15 mg-r-6 f-w-b over-1">{{ item.title }}</span>
                                <span
                                    v-for="(item, index) in item.tag_list"
                                    :key="index"
                                    class="pad-0-4 bor-radiu-4 bg-c-FFE6E6 fs-10 c-FF0202 h-18 l-18 ds-bl mg-r-5"
                                >{{ item.label }}</span>
                            </div>
                            <div class="">
                                <p class="l-20 fs-14 c-6">{{item.realname}}&nbsp;{{ item.cert_no }}</p>
                            </div>
                        </div>
                    </div>

                    <div class="w-52">
                        <button
                            :class="['bd-init', 'bg-init', 'bg-c-w', 'w-52', 'h-26', 'bs-border-box', 'bor-radiu-4', 'fs-13', {
                                // 私信
                                'bg-i-direct': item.is_follow == 'yes' && item.can_letter == 'yes',
                                // 已关注
                                'bg-i-follow': item.is_follow == 'yes' && item.can_letter == 'no',
                                // 未关注
                                'bg-i-unfollow': item.is_follow == 'no'
                            }]"
                            @click.stop.prevent="followUserFn(item, index)"
                        ></button>
                    </div>
                </div>

                <div class="">
                    <p class="l-18 c-93 fs-13">{{item.intro}}</p>
                </div>
            </div>

            <div class="txt-center fs-14 c-93 l-18 mg-t-12" v-if="memberTips">——&nbsp;{{memberTips}}&nbsp;——</div>
            <div class="txt-center fs-14 c-93 l-18 mg-t-5">{{intro}}</div>
        </div>
    </div>
</template>
<script>
import { isLoginInfo } from "@/utils/index";
import userHomeApi from "@/api/user_home/index.js";
export default {
    name: "memberArea",
    data() {
        return {
            memberList: [],
            memberTips: "",
            intro: "",
            reqType: false,
            token: "",
            user_id: ""
        }
    },
    created() {
        
        let _this = this;
        window.srNativeCallH5Method = (data) => {
            let params = null;
            params = handleSpecialCharacters(data);
            let obj = {};
            if(params && params.params) {
                obj = params.params;
            }
            if(params.method_name == 'send_user_token'){
                if(obj.token && obj.token.indexOf('Bearer') == -1) {
                    obj.token = "Bearer " + obj.token;
                }
                _this.token = obj.token;
                _this.user_id = obj.u_id;
                _this.getList();
                _this.$forceUpdate();
            }
        };

        function handleSpecialCharacters(jsonStr) {
            let obj = {};
            if (jsonStr && Object.prototype.toString.call(jsonStr) == "[object String]" && jsonStr != 'null') {
                jsonStr = jsonStr.replace(/\n/g, "\<br/>");
                obj = JSON.parse(jsonStr)
            }
            return obj;
        }

        let query = this.$route.query;
        if(query && Object.keys(query).length > 0 && query.u_id && query.Authorization) {
            this.token = query.Authorization;
            this.user_id = query.u_id
            this.getList();
        } else {
            this.getList();
            this.$srH5CallNativeMethodApp('need_user_token', "");
        }

        console.info(query, 'query')

        
    },
    mounted() {
    },
    methods: {
        // 点击关注按钮
        followUserFn(item, index) {
            if(this.reqType) {
                return
            }
            this.reqType = true;

			if(!this.token) {
                this.reqType = false;
                this.$srH5CallNativeMethodApp('is_login_page',{})
				return
			}
            // 去私信
            if(item.is_follow == 'yes' && item.can_letter == 'yes') {
                this.reqType = false;
                this.$srGoToLetterMsg(item.id);
            } 
            // 取消关注
            else if(item.is_follow == 'yes' && item.can_letter == 'no') {
                this.cancelFollowFn(item.l_id, index)
            }
            // 去关注
            else if(item.is_follow == 'no') {
                // 调用关注API
                this.followUser(item.l_id, index);
            }
        },

        // 点击关注用户
		async followUser(id, index) {
		    let res = await userHomeApi.setFollowLive({
		        id: id,
		        act: "follow",
                user_id: this.user_id,
                u_id: this.user_id,
                Authorization: this.token
		    })
		    if(res.rslt == 'succ') {
		        this.$set(this.memberList[index], 'is_follow', "yes");

                this.$srH5CallNativeMethodApp('notice_live_follow',{
                    'lid': id,
                })
		    }
            this.reqType = false;
		},

        async cancelFollowFn(id, index) {
			let res = await userHomeApi.setFollowLive({
			    id: id,
			    act: "unfollow",
                user_id: this.user_id,
                u_id: this.user_id,
                Authorization: this.token
			})
			if(res.rslt == 'succ') {
                this.$set(this.memberList[index], 'is_follow', "no");

                // 通知客户端打开对话框
                this.$srH5CallNativeMethodApp('notice_live_unfollow',{
                    'lid': id
                })
			}
            this.reqType = false;
		},

        async getList() {
            let res = await userHomeApi.serverVipList({
                user_id: this.user_id,
                u_id: this.user_id,
                Authorization: this.token
            })
            if(res.result == 'success' && res.data && res.data.list && res.data.list.length > 0) {
                this.memberList = res.data.list;
                this.memberTips = res.data.desc;
                this.intro = res.data.intro;
            }
        },

        goDetail(item) {
            let params = {
                kind: 'person_page', // 类型
            };

            let query = {
				o_kind: 'live_msg', // 用户身份（投顾老师、普通用户
				id: item.l_id
			}

            // 同步传参
            params = {
                ...params,
                ...query
            }
            this.$srH5CallNativeMethodApp('call_Native',params)
        }
    }
}
</script>
<style scoped lang="scss">
@import "~@/assets/sass/global.scss";

/* 背景图片 - 初始化 */
.bg-init {
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
}

/* 边框 */
.bd-init {
    border: none;
    outline: none;
}

/* 溢出显示省略号 */
.over-1 { text-overflow: ellipsis; overflow: hidden; }

/* 隐藏 */
.over-hide { overflow: hidden; }

/* 盒子 - 宽度 */
.w-48 { width: 48px; }

.w-52 { width: 52px; }

.w-b-100 { width: 100%; }

/* 盒子 - 高度 */
.h-18 { height: 18px; }

.h-21 { height: 21px; }

.h-26 { height: 26px; }

.h-48 { height: 48px; }

.h-b-100 { height: 100%; }

.m-h-b-100 { min-height: 100vh; }

/* 内边距 */
.pad-20-18 { padding: 20px 18px; }

.pad-0-4 { padding: 0 4px; }

.pad-0 { padding: 0; }

.pad-12 { padding: 12px; }

.pad-t-10 { padding-top: 10px; }

.pad-r-10 { padding-right: 10px; }

.pad-b-10 { padding-bottom: 10px; }

.pad-l-10 { padding-left: 10px; }

/* 外边距 */
.mg-t-2 { margin-top: 2px; }

.mg-t-5 { margin-top: 5px; }

.mg-t-12 { margin-top: 12px; }

.mg-r-5 { margin-right: 5px; }

.mg-r-6 { margin-right: 6px; }


.mg-r-10 { margin-right: 10px; }

.mg-b-4 { margin-bottom: 4px; }

.mg-b-12 { margin-bottom: 12px; }

.mg-l-5 { margin-left: 5px; }

/* 字体尺寸 */
.fs-10 { font-size: 10px; }

.fs-12 { font-size: 12px; }

.fs-13 { font-size: 13px; }

.fs-14 { font-size: 14px; }

.fs-15 { font-size: 15px; }

/* 字体行高 */
.l-18 { line-height: 18px; }

.l-20 { line-height: 20px; }

.l-21 { line-height: 21px; }

/* 字体加粗 */
.f-w-b { font-weight: bold; }

.f-w-600 { font-weight: 600; }

.f-w-500 { font-weight: 500; }

.f-w-400 { font-weight: 400; }

/* 字体颜色 */
.c-9E3E2E { color: #9E3E2E; }

.c-f { color: #fff; }

.c-3 { color: #333; }

.c-6 { color: #666; }

.c-63 { color: #636363; }

.c-93 { color: #939393; }

.c-FF0202 { color: #FF0202; }

/* 字体不换行 */
.wp-nw { white-space: nowrap; }

/* 圆角 */
.bor-radiu-4 { border-radius: 4px; }

.bor-radiu-8 { border-radius: 8px; }

.bor-radiu-w-50 { border-radius: 50%; }

/* 盒模型-不计算内边距 */
.bs-border-box { box-sizing: border-box; }


/* 背景图片 - 不重复渲染 */
.bg-no-repeat { background-repeat: no-repeat; }

/* 背景图片 - 尺寸100% */
.bg-size-100 { background-size: 100%; }

.bg-s-15 { background-size: 15px; }

.bg-size-100-auto {
  background-size: 100% auto;
}

/* 背景图片 - 居中 */
.bg-pos-center { background-position: center; }

.bg-p-x-0 { background-position-x: 0; }

.bg-p-x-r { background-position-x: right; }

.bg-p-y-0 { background-position-y: 0; }

/* 背景颜色 */
.bg-c-trans { background-color: transparent; }

.bg-c-w { background-color: #fff; }

.bg-c-FFE6E6 { background-color: #FFE6E6; }

.bg-c-F5F6F7 { background-color: #F5F6F7; }

.bg-c-FF443D { background-color: #FF443D; }

/* 背景图片 */

.bg-i-direct { background-image: url("https://cdncos.aigupiao.com/assets/jf/svg/member_area_direct_msg.svg"); }

.bg-i-follow { background-image: url("https://cdncos.aigupiao.com/assets/jf/svg/member_area_follow.svg"); }

.bg-i-unfollow { background-image: url("https://cdncos.aigupiao.com/assets/jf/svg/member_area_un_follow.svg"); }

/* 盒子阴影 */
.box-shadow-8090A0 { box-shadow: 0px 0px 5px 0px #8090A01A;}

/* 背景颜色 - 渐变 */
.bg-liner-F5E2B6-F3D076 { background: linear-gradient(180deg, rgba(245, 226, 182, 0.2) 0%, rgba(243, 208, 118, 0) 100%); }

.bg-liner-FDE4C3-F7CA8B { background: linear-gradient(90deg, #FDE4C3 0%, #F7CA8B 100%); }

/* 盒子容器 */
.ds-bl { display: block; }

/* 弹性盒布局 */
.ds-fl { display: flex; }

/* 弹性盒布局 - 布局方向 */
.fl-dir-c { flex-direction: column; }

.fl-dir-r { flex-direction: row; }

/* 弹性盒布局 - 垂直居中 */
.al-center { align-items: center; }

.jc-center { justify-content: center; }

.jc-bt { justify-content: space-between; }

.jt-ar { justify-content: space-around; }

.fl-1 { flex: 1; }

.txt-center { text-align: center; }

.b-b-l-EbEDF0 { border-bottom: 1px solid #EBEDF0; }

/* 定位 */
.pos-f {
  position: fixed;
}

/* 线条 */
.l-line {

}
</style>